angular.module("componentes").directive("messageBar", function () {
	"use strict";
	return {
		scope: {},
		controller: "messageBarCtrl",
		controllerAs: "ctrl"
	};
});
